import React, { useEffect, useState } from 'react';
import { adminApi, fmtDate } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminAdminsPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ email: '', password: '', first_name: '', last_name: '', role: 'accountant' });

  const load = () => adminApi.get('/admin/admins').then(r => setItems(r.data.items || []));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try {
      await adminApi.post('/admin/admins', form);
      toast.success('Admin created');
      setOpen(false); setForm({ email: '', password: '', first_name: '', last_name: '', role: 'accountant' }); load();
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed'); }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl text-[hsl(var(--brand-navy-2))]">Administrators</h1>
        <Button onClick={() => setOpen(true)} className="bg-[hsl(var(--brand-navy))]"><Plus className="h-4 w-4 mr-1" />Add admin</Button>
      </div>
      <Card className="bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[hsl(var(--secondary))]"><tr><th className="p-3 text-left">Email</th><th className="p-3 text-left">Name</th><th className="p-3 text-left">Role</th><th className="p-3 text-left">Created</th><th className="p-3 text-left">Last login</th></tr></thead>
          <tbody>
            {items.map(a => (
              <tr key={a.user_id} className="border-t">
                <td className="p-3">{a.email}</td>
                <td className="p-3">{a.first_name} {a.last_name}</td>
                <td className="p-3"><span className="inline-flex items-center rounded-full bg-[hsl(var(--brand-gold))]/10 px-2 py-0.5 text-xs font-medium text-[hsl(var(--brand-navy))]">{a.role}</span></td>
                <td className="p-3 text-xs">{fmtDate(a.created_at)}</td>
                <td className="p-3 text-xs">{fmtDate(a.last_login)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>New administrator</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <div><Label>First name</Label><Input value={form.first_name} onChange={e => setForm({ ...form, first_name: e.target.value })} /></div>
              <div><Label>Last name</Label><Input value={form.last_name} onChange={e => setForm({ ...form, last_name: e.target.value })} /></div>
            </div>
            <div><Label>Email</Label><Input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></div>
            <div><Label>Password</Label><Input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} /></div>
            <div><Label>Role</Label>
              <Select value={form.role} onValueChange={v => setForm({ ...form, role: v })}><SelectTrigger><SelectValue /></SelectTrigger><SelectContent>
                <SelectItem value="super_admin">super_admin</SelectItem>
                <SelectItem value="administrator">administrator</SelectItem>
                <SelectItem value="compliance">compliance</SelectItem>
                <SelectItem value="kyc_manager">kyc_manager</SelectItem>
                <SelectItem value="accountant">accountant</SelectItem>
              </SelectContent></Select>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={create} className="bg-[hsl(var(--brand-navy))]">Create</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
